import React, { Component } from "react";
//Alert dialog
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { connect } from "react-redux";

class UnclaimedPromoDialog extends Component {
  render() {
    const language = this.props.language;
    return (
      <Dialog
        open={this.props.dialogOpen}
        onClose={() => this.props.onClose()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ textAlign: language == "english" ? "left" : "right" }}
          >
            {language == "english"
              ? "you have unclaimed promotional products, are you sure you want to skip promotion ? "
              : "لديك منتجات مجانية غير مضافة الى سلة الشراء, هل انت  متأكد انك تريد تخطي العرض؟"}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{
            justifyContent: language == "english" ? "flex-end" : "flex-start",
          }}
        >
          <Button
            onClick={() => this.props.handleDialogContinue()}
            color="primary"
          >
            {language == "english" ? "Skip promotion" : "تخطي العرض"}
          </Button>
          <Button
            onClick={() => this.props.handleDialogClaimItems()}
            color="primary"
          >
            {language == "english" ? "Add items" : "أضف المنتجات"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
  };
};

export default connect(mapStateToProps)(UnclaimedPromoDialog);
